import { getInternalMaterialProductName, SiteMaterialList } from 'api';
import { formatDate } from 'date';
import { useTranslation } from 'i18n';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Table, TableBody, TableContainer, TableHead, Typography } from 'ui';

import { StyledTableCell, StyledTableRow } from './styles';

const getSiteMaterialName = (siteMaterial: SiteMaterialList): string => {
  const materialProduct = siteMaterial.material_product;
  let materialName = materialProduct
    ? getInternalMaterialProductName(materialProduct)
    : `${siteMaterial.material_spec.title} - ${siteMaterial.grade.name}`;
  if (siteMaterial.seller_label) {
    materialName += ` - Seller label: ${siteMaterial.seller_label}`;
  }
  return materialName;
};

export const SiteMaterialsList = ({
  siteName,
  siteMaterials,
}: {
  siteMaterials: SiteMaterialList[];
  siteName: string;
}) => {
  const { t } = useTranslation('orders');
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        mb: 4,
      }}
    >
      <Box
        sx={{
          mb: 1,
          pl: 1.25,
        }}
      >
        <Typography variant="body1" fontWeight="bold">
          {siteName}
        </Typography>
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <StyledTableRow sx={(theme) => ({ color: theme.palette.text.secondary })}>
              <StyledTableCell>{t('siteMaterials.siteMaterialsList.columns.material')}</StyledTableCell>
              <StyledTableCell>{t('siteMaterials.siteMaterialsList.columns.lastUpdated')}</StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {siteMaterials.map((row) => (
              <StyledTableRow key={row.id}>
                <StyledTableCell
                  sx={{
                    minWidth: '250px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {getSiteMaterialName(row)}
                </StyledTableCell>
                <StyledTableCell>{formatDate(row.updated_at)}</StyledTableCell>
                <StyledTableCell sx={{ justifyContent: 'right' }}>
                  <Stack
                    direction="row"
                    sx={{
                      gap: 1.5,
                      justifyContent: 'end',
                    }}
                  >
                    <Button variant="secondary" onClick={() => navigate(`${row.id}/update/`)}>
                      {t('siteMaterials.siteMaterialsList.actions.editAssignProduct')}
                    </Button>
                  </Stack>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
